// Only exported function that is actually used in the codebase
export function isNullOrUndefined(data) {
  return (data === null || data === undefined);
}
